export enum CLICK_ACTION_TYPE {
    WebView = "webView",
    InAppLink = "in_app_link",
    WebLink = "web_link"
}